<template>
  <div
    class="about p-8 flex justify-center items-center"
    v-motion
    :initial="initialMotion"
    :enter="enterMotion"
  >
    <div class="w-full lg:w-3/5 lg:mt-8">
      <h3 class="font-semibold">Sobre</h3>
      <h6 class="mt-8 text-justify font-[500]">
        O sistema Homero é uma plataforma de educação adaptativa que utiliza
        recursos de inteligência artificial para permitir que os alunos tenham
        uma experiência de aprendizado compatível com sua disponibilidade e
        condições de aprendizado. <br /><br />

        Iniciativa do Ministério da Ciência, Tecnologia e Inovações e Softex no
        âmbito do Programa MCTI FUTURO. <br /><br />

        Projeto apoiado pelo Ministério da Ciência, Tecnologia e Inovações, com
        recursos da Lei nº 8.248, de 23 de outubro de 1991.
      </h6>
    </div>
  </div>
</template>

<script lang="ts">
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { defineComponent } from "vue";

export default defineComponent({
  name: "about",
  data() {
    return {
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(40)),
    };
  },
});
</script>

<style lang="scss" src="./style.scss"></style>
